import { EditCommand } from "./EditCommand";

export abstract class AbstractSortValueOfArrayCommand<TSource, TValue> extends EditCommand<TSource, TValue[]> {
  constructor(compare: (a: TValue, b: TValue) => number) {
    super(
      s => this.readArray(s).concat(),
      s => this.readArray(s).sort(compare),
      (s, b) => this.revertArray(this.readArray(s), b),
    );
  }

  private revertArray(source: TValue[], backupped: TValue[]): void {
    for (let i = 0; i < backupped.length; i++) {
      source[i] = backupped[i];
    }
  }

  protected abstract readArray(source: TSource): TValue[];
}
